import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

const PersonData = ({ person } = {}) => {
  const { name, imageURL } = person;
  const image = imageURL || undefined;
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'Person',
    name,
    image,
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

PersonData.propTypes = {
  person: PropTypes.object,
};

export default PersonData;
